import { useEffect } from "react";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { fetchStateCompliances, saveStateCompliance, getEditDocument } from "../slice/workerComplianceSlice";
import { useState } from "react";
import { forwardRef, useImperativeHandle } from "react";
import { useNavigate } from "react-router-dom";

const WorkerAddCompliance = forwardRef((props, ref) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { data: stateData, loading, error, editDocument } = useSelector(
    (state) => state.workerCompliance
  );
  const { userData } = useSelector(
    (state) => state.workerInfo
  );

  // useImperativeHandle(ref, () => ({
  //   reset() {
  //     setSelectedFile(null);
  //     setSelectedFiles({});
  //     setSuccessMessage("");
  //     setComplianceStatus(null);
  //     setSaving(false);
  //     setIsSubmitted(false);
  //   }
  // }));
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedFiles, setSelectedFiles] = useState({});
  const [saving, setSaving] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  // const [userData, setUserData] = useState(null);
  const token = localStorage.getItem("token");
  const isEditMode = Array.isArray(editDocument) && editDocument.length > 0;
  const complianceId = editDocument?.[0]?.id;
  const [educationLevel, setEducationLevel] = useState("");

  const [checks, setChecks] = useState({
    background: {},
    teacher: {},
    support_staff: {},
  });

  const [fingerprint, setFingerprint] = useState({
    file: null,
    fileUrl: "",       // from API
    expiration_date: "",
    isUpdated: false,  // track if user changed anything
  });




  const states = userData?.states;

  console.log("states", states);

  const closeComplianceModal = () => {
    const modalEl = document.getElementById("addComplianceModal");

    if (modalEl && window.bootstrap) {
      const modal = window.bootstrap.Modal.getInstance(modalEl);
      modal?.hide();
    }

    // 🔥 Force cleanup (fix black backdrop issue)
    document.body.classList.remove("modal-open");

    document.querySelectorAll(".modal-backdrop").forEach((el) => el.remove());
  };



  useEffect(() => {
    if (!states || !token) return;

    dispatch(getEditDocument(token));
  }, [states, token, dispatch]);

  console.log("editDocument", editDocument);

  useEffect(() => {
    setEducationLevel(editDocument.education_level);
  }, [editDocument.education_level]);

  useEffect(() => {
    if (!editDocument?.documents) return;

    const prefilled = {};

    Object.entries(editDocument.documents).forEach(([docKey, doc]) => {
      prefilled[docKey] = {
        file: null,
        fileUrl: doc.fileUrl,
        expiration_date: doc.expiration_date,
        isUpdated: false,
      };
    });

    setSelectedFiles(prefilled);
  }, [editDocument]);


  useEffect(() => {
    if (!editDocument) return;

    setChecks({
      background: editDocument.background || {},
      teacher: editDocument.teacher || {},
      support_staff: editDocument.support_staff || {},
    });
  }, [editDocument]);

  useEffect(() => {
    if (!editDocument?.fingerprint) return;

    setFingerprint({
      file: editDocument.fingerprint.file,
      fileUrl: editDocument.fingerprint.fileUrl,
      expiration_date: editDocument.fingerprint.expiration_date,
      isUpdated: false,
    });
  }, [editDocument]);



  // useEffect(() => {
  //   if (saveResponse?.success) {
  //     setSuccessMessage(saveResponse.message); // "State compliance saved successfully."
  //     setComplianceStatus(saveResponse.data); // { document_upload: true, ... }
  //   }
  // }, [saveResponse]);


  useEffect(() => {
    if (!states || !token) return;

    dispatch(fetchStateCompliances({ states, token }));
  }, [states, token, dispatch]);

  const makeDocKey = (name) => {
    return name
      .toLowerCase()
      .replace(/\//g, "")      // remove /
      .replace(/\s+/g, "_")    // space → _
      .replace(/[^a-z0-9_]/g, ""); // remove other special chars
  };



  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();

    // 🔹 ACTION PARAM
    formData.append("action", isEditMode ? "update" : "create");

    // 🔹 Needed in both cases
    formData.append("state_code", states);

    formData.append("education_level", educationLevel);

    let hasUpdatedDocs = false;

    Object.entries(selectedFiles).forEach(([docKey, data]) => {
      // CREATE → send everything
      if (!isEditMode) {
        if (data.file) {
          formData.append(`documents[${docKey}][file]`, data.file);
        }
        if (data.expiration_date) {
          formData.append(
            `documents[${docKey}][expiration_date]`,
            data.expiration_date
          );
        }
      }

      // UPDATE → send ONLY updated documents
      if (isEditMode && data.isUpdated) {
        hasUpdatedDocs = true;

        if (data.file) {
          formData.append(`documents[${docKey}][file]`, data.file);
        }
        if (data.expiration_date) {
          formData.append(
            `documents[${docKey}][expiration_date]`,
            data.expiration_date
          );
        }
      }
    });

    // ⛔ Prevent empty update
    if (isEditMode && !hasUpdatedDocs) {
      alert("No changes detected");
      return;
    }

    // 🔹 CREATE → include checks
    if (!isEditMode) {
      Object.entries(checks.background).forEach(([key, value]) => {
        formData.append(`checks[background][${key}]`, value);
      });

      Object.entries(checks.teacher).forEach(([key, value]) => {
        formData.append(`checks[teacher][teacher_${key}]`, value);
      });

      Object.entries(checks.support_staff).forEach(([key, value]) => {
        formData.append(`checks[support_staff][support_staff_${key}]`, value);
      });
    }

    // Fingerprint → send only if create or updated
    if (!isEditMode || fingerprint.isUpdated) {
      if (fingerprint.file) {
        formData.append("fingerprint", fingerprint.file);
        // formData.append("fingerprint_is_uploaded", 1);


      }
      // console.log("fingerprint.file",fingerprint.file);
      // console.log("length",editDocument.fingerprint);
      else if (!fingerprint.file && fingerprint.fileUrl) {
        formData.append("fingerprint_is_uploaded", 1);
      }
      if (fingerprint.expiration_date) {
        formData.append("fingerprint_expiration", fingerprint.expiration_date);
      }
    }



    const result = await dispatch(
      saveStateCompliance({ token, formData })
    );

    if (result.meta.requestStatus === "fulfilled") {
      // setSaving(true);
      // setTimeout(() => {
      //   setSaving(false);
      //   setIsSubmitted(true);
      // }, 3000);
      toast.success("Update Successful", {
        position: "top-right",
        autoClose: 2000,
        style: { fontSize: "0.85rem" },
      });

      closeComplianceModal();

      navigate('/panel');
    } else {
      toast.error("Please fill all the required fields.", {
        position: "top-right",
        autoClose: 2000,
        style: { fontSize: "0.85rem" },
      });
    }
  };


  if (saving) {
    return (
      <div className="text-center mt-5">
        <div className="spinner-border text-primary" />
        <p className="mt-2">Saving, please wait...</p>
      </div>
    );
  }

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error.message}</div>;
  if (!stateData) return null;

  const { role_id } = userData;

  return (
    <>
      <div className="container-fluid d-flex justify-content-center mt-4">
        <div className="w-100 px-3 px-md-5">
          {/* <h4 className="font-weight-bold text-primary font-size-40 mb-4 pb-1 border-bottom pb-3 montserrat">
                        Add Compliance
                    </h4> */}

          <div className="form-section mt-3">
            {!isSubmitted && (
              <form onSubmit={handleSubmit}>
                <div className="row g-3">


                  {/* Min Age */}
                  <div className="col-sm-6">
                    <label className="form-label text-primary mb-1 font-weight-semibold">Minimum Age</label>
                    <input type="number" className="form-control" defaultValue={stateData.min_age} readOnly />
                  </div>

                  {/* Medical Clearance */}
                  <div className="col-sm-6">
                    <label className="form-label text-primary mb-1 font-weight-semibold">Medical Clearance Required</label>
                    <input type="text" className="form-control" defaultValue={stateData.medical_clearance_required} readOnly />

                  </div>

                  <div className="col-sm-6">
                    <label className="form-label text-primary mb-1 font-weight-semibold">Pending Clearance Allowed</label>
                    <input type="text" className="form-control" defaultValue={stateData.pending_clearance_allowed} readOnly />

                  </div>

                  <div className="col-sm-6">
                    <label className="form-label text-primary mb-1 font-weight-semibold">Provisional Hire</label>
                    <input type="text" className="form-control" defaultValue={stateData.provisional_hire} readOnly />

                  </div>

                  <div className="col-sm-6">
                    <label className="form-label text-primary mb-1 font-weight-semibold">Training initial hours</label>
                    <input type="number" className="form-control" defaultValue={stateData.training_initial_hours} readOnly />

                  </div>

                  <div className="col-sm-6">
                    <label className="form-label text-primary mb-1 font-weight-semibold">Training annual hours</label>
                    <input type="number" className="form-control" defaultValue={stateData.training_annual_hours} readOnly />

                  </div>

                  <div className="col-sm-6">
                    <label className="form-label text-primary mb-1 font-weight-semibold required">
                      Education Level
                    </label>

                    <select
                      className="form-control"
                      value={educationLevel}
                      onChange={(e) => setEducationLevel(e.target.value)}
                      required
                    >
                      <option value="">Select Education Level</option>
                      {stateData.education_levels.map((level, index) => (
                        <option value={level} key={index}>{level}</option>
                      ))}
                    </select>

                  </div>


                  {/* DOCUMENTS LIST */}
                  <div className="col-12 mt-4">
                    <h5 className="text-primary">Required Documents</h5>
                  </div>

                  {stateData.documents.map((doc) => {
                    const docKey = makeDocKey(doc.document_name);

                    return (
                      <div className="col-12 border rounded p-3 mb-3" key={doc.id}>
                        <div className="d-flex justify-content-between align-items-center mb-2">
                          <h6 className="text-dark mb-0">{doc.document_name}</h6>
                          {doc.required ? (
                            <span className="badge bg-danger">Required</span>
                          ) : (
                            <span className="badge bg-info text-dark">Optional</span>
                          )}
                        </div>

                        <div className="row g-3 align-items-start">
                          {/* FILE UPLOAD (same as fingerprint design) */}
                          <div className="col-md-6">
                            <label className="form-label text-primary mb-1 font-weight-semibold">
                              Document File
                            </label>

                            <div className="uploadfield flex-fill">
                              <div className="custom-file-upload position-relative">
                                <button
                                  type="button"
                                  className="upload-btn btn btn-light-header position-absolute"
                                  onClick={() =>
                                    document.getElementById(`docFile-${doc.id}`)?.click()
                                  }
                                >
                                  Upload Files
                                </button>

                                <input
                                  type="file"
                                  id={`docFile-${doc.id}`}
                                  hidden
                                  onChange={(e) => {
                                    const file = e.target.files[0] || null;

                                    setSelectedFiles((prev) => ({
                                      ...prev,
                                      [docKey]: {
                                        ...prev[docKey],
                                        file,
                                        isUpdated: true,
                                      },
                                    }));
                                  }}
                                />
                              </div>

                              {/* 🔹 Input display (ALWAYS same text) */}
                              <div className="file-name form-control text-truncate">
                                {selectedFiles[docKey]?.file?.name || "No file chosen"}
                              </div>


                              {/* 🔹 View link BELOW input */}
                              {(selectedFiles[docKey]?.fileUrl ||
                                selectedFiles[docKey]?.file) && (
                                  <div className="mt-1">
                                    <a
                                      href={
                                        selectedFiles[docKey]?.file
                                          ? URL.createObjectURL(selectedFiles[docKey].file)
                                          : selectedFiles[docKey].fileUrl
                                      }
                                      target="_blank"
                                      rel="noreferrer"
                                      className="text-primary text-decoration-underline small"
                                    >
                                      View Uploaded File
                                    </a>
                                  </div>
                                )}
                            </div>
                          </div>


                          {/* EXPIRATION DATE */}
                          <div className="col-md-6">
                            <label className="form-label text-primary mb-1 font-weight-semibold">
                              Expiration Date
                            </label>
                            <input
                              type="date"
                              className="form-control"
                              value={selectedFiles[docKey]?.expiration_date || ""}
                              onChange={(e) => {
                                setSelectedFiles((prev) => ({
                                  ...prev,
                                  [docKey]: {
                                    ...prev[docKey],
                                    expiration_date: e.target.value,
                                    isUpdated: true,
                                  },
                                }));
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    );
                  })}

                  {/* STATE CHECK */}
                  <div className="col-12 mt-4">
                    <h5 className="text-primary">State Background Check</h5>
                  </div>

                  <div className="col-sm-6">
                    <label className="form-label text-primary mb-1 font-weight-semibold">Fingerprint Required</label>
                    <input type="text" className="form-control" defaultValue={stateData.state_check.fingerprint_required} readOnly />
                  </div>
                  <div className="col-sm-6">
                    <label className="form-label text-primary mb-1 font-weight-semibold">Fingerprint Method</label>
                    <input type="text" className="form-control" defaultValue={stateData.state_check.fingerprint_method} readOnly />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label text-primary mb-1 font-weight-semibold">
                      Fingerprint Document
                    </label>

                    <div className="uploadfield flex-fill">
                      <div className="custom-file-upload position-relative">
                        <button
                          type="button"
                          className="upload-btn btn btn-light-header position-absolute"
                          onClick={() =>
                            document.getElementById("docFile-fingerprint")?.click()
                          }
                        >
                          Upload File
                        </button>

                        <input
                          type="file"
                          id="docFile-fingerprint"
                          hidden
                          onChange={(e) => {
                            const file = e.target.files[0] || null; // <-- binary file
                            setFingerprint((prev) => ({
                              ...prev,
                              file,          // store selected file here
                              isUpdated: true
                            }));
                          }}
                        />
                      </div>

                      <div
                        className="file-name form-control text-truncate"
                        title={fingerprint.file?.name || fingerprint.fileUrl || ""}
                      >
                        {fingerprint.file
                          ? fingerprint.file.name
                          : fingerprint.fileUrl
                            ? <a href={fingerprint.fileUrl} target="_blank" rel="noreferrer" className="text-primary text-decoration-underline">View Uploaded File</a>
                            : "No file chosen"}
                      </div>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <label className="form-label text-primary mb-1 font-weight-semibold">
                      Expiration Date
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      value={fingerprint.expiration_date || ""}
                      onChange={(e) =>
                        setFingerprint((prev) => ({
                          ...prev,
                          expiration_date: e.target.value,
                          isUpdated: true
                        }))
                      }
                    />
                  </div>


                  {/* <div className="col-md-6">
                    <label className="form-label text-primary mb-1 font-weight-semibold">
                      Expiration Date
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      value={fingerprint.expiration_date || ""}
                      onChange={(e) =>
                        setFingerprint((prev) => ({
                          ...prev,
                          expiration_date: e.target.value,
                          isUpdated: true,
                        }))
                      }
                    />
                  </div> */}

                  <div className="row g-3">
                    {/* Background Checks */}
                    {stateData.state_check.background_checks.map((check, index) => (
                      <div className="col-sm-6" key={index}>
                        <label className="form-label text-primary mb-1 font-weight-semibold">
                          {check} Check
                        </label>

                        <select
                          className="form-control"
                          value={
                            checks.background[check] === undefined
                              ? ""
                              : checks.background[check]
                                ? "true"
                                : "false"
                          }
                          onChange={(e) =>
                            setChecks((prev) => ({
                              ...prev,
                              background: {
                                ...prev.background,
                                [check]: e.target.value === "true",
                              },
                            }))
                          }
                          required
                        >
                          <option value="">Select</option>
                          <option value="true">Yes</option>
                          <option value="false">No</option>
                        </select>

                      </div>
                    ))}

                    {role_id == 5 && (
                      <>
                        {/* Teacher Checks */}
                        {Object.entries(stateData.state_check.teacher_checks).map(
                          ([key, value], index) => (
                            <div className="col-sm-6" key={index}>
                              <label className="form-label text-primary mb-1 font-weight-semibold">
                                Teacher {key.replace(/_/g, " ")}
                              </label>

                              <select
                                className="form-control"
                                value={
                                  checks.teacher[key] === undefined
                                    ? ""
                                    : checks.teacher[key]
                                      ? "true"
                                      : "false"
                                }
                                onChange={(e) =>
                                  setChecks((prev) => ({
                                    ...prev,
                                    teacher: {
                                      ...prev.teacher,
                                      [key]: e.target.value === "true",
                                    },
                                  }))
                                }
                              >
                                <option value="">Select</option>
                                <option value="true">Yes</option>
                                <option value="false">No</option>
                              </select>

                            </div>
                          )
                        )}
                      </>
                    )}

                    {role_id == 6 && (
                      <>
                        {/* Support Staff Checks */}
                        {Object.entries(stateData.state_check.support_staff_checks).map(
                          ([key, value], index) => (
                            <div className="col-sm-6" key={index}>
                              <label className="form-label text-primary mb-1 font-weight-semibold">
                                Support Staff {key.replace(/_/g, " ")}
                              </label>

                              <select
                                className="form-control"
                                value={
                                  checks.support_staff[key] === undefined
                                    ? ""
                                    : checks.support_staff[key]
                                      ? "true"
                                      : "false"
                                }
                                onChange={(e) =>
                                  setChecks((prev) => ({
                                    ...prev,
                                    support_staff: {
                                      ...prev.support_staff,
                                      [key]: e.target.value === "true",
                                    },
                                  }))
                                }
                              >
                                <option value="">Select</option>
                                <option value="true">Yes</option>
                                <option value="false">No</option>
                              </select>

                            </div>
                          )
                        )}
                      </>
                    )}

                  </div>
                </div>

                <div className="mt-4 text-center">
                  <button type="submit" className="btn btn-light-header px-5">Save</button>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </>
  );
});

export default WorkerAddCompliance;